
export const reindex = (arr) => arr.map((item, idx) => ({ ...item, index: idx }));

export const insertAtIndex = (arr, newItem, idx) => {
  if (idx < 0) return arr;

  const actualIndex = idx === (Infinity || idx > arr.length) ? arr.length : idx;

  const newArr = [
    ...arr.slice(0, actualIndex),
    // new item gets a placeholder index (real index assigned in reindex)
    { ...newItem, index: actualIndex },
    ...arr.slice(actualIndex),
  ];
  return reindex(newArr);
};

// Remove an item at a specific index, then reindex
export const removeAtIndex = (arr, idx) => {
  const newArr = [...arr.slice(0, idx), ...arr.slice(idx + 1)];
  return reindex(newArr);
};
 
export const moveItem = (arr, fromIndex, toIndex) => {
  const item = arr[fromIndex];
  const withoutItem = [...arr.slice(0, fromIndex), ...arr.slice(fromIndex + 1)];
  const inserted = [
    ...withoutItem.slice(0, toIndex),
    item,
    ...withoutItem.slice(toIndex),
  ];
  return reindex(inserted);
};